/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
const deps = ['Api'];
const factory = function (Api) {
  class CategorizerApi extends Api {
    constructor() {
      super('categorizer');
    }
  }

  return new CategorizerApi();
};

factory.$inject = deps;
module.exports = factory;
